<template>
  <a-card v-if="!loading" :title="'گزارش سمینار  ' + info.title">
    <div class="row">
      <div class="col-md-3" style="flex: 0 0 auto; width: 25%; display: flex">
        <a-card title="گزارش کلی سمینار" :style="{ marginTop: '16px' }">
          <a-card-grid
            style="width: 50%; text-align: center"
            :hoverable="false"
          >
            کل مبلغ فروش
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            {{ $root.number_format(info.sold_amount) }}
          </a-card-grid>
          <a-card-grid
            style="width: 50%; text-align: center"
            :hoverable="false"
          >
            تعداد تیم اجرایی
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            {{ info.hosts.length }}
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            تعداد کل قرارداد
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            {{ info.count_contracts }}
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            پرفروش ترین کارشناس
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            {{
              best_seller
                ? best_seller.user.firstname + " " + best_seller.user.lastname
                : " - "
            }}
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            پرفروش ترین سانس
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            {{
              info.best_sans
                ? info.best_sans.start_hour + "-" + info.best_sans.end_hour
                : "-"
            }}
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            تعداد افراد دعوتی
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            {{ info.count_invites }}
          </a-card-grid>
          <a-card-grid style="width: 50%; text-align: center">
            تعداد افراد حاضر سمینار
          </a-card-grid>

          <a-card-grid style="width: 50%; text-align: center">
            {{ info.count_presents }}
          </a-card-grid>
        </a-card>
      </div>
      <div class="col-md-9">
        <a-card
          title=" گزارش بر اساس قرارداد ها"
          :style="{ marginTop: '16px' }"
        >
          <a type="link" target="_blank" :href="`${$store.state.baseUrl}/seminars/${info.id}/contracts`">دانلود گزارش </a>
          <div class="row justify-content-center">
            <div class="col-md-10">
              <div>
                <section class="w-100 p-4 text-center">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">شناسه</th>
                          <th scope="col">شماره موبایل</th>
                          <th scope="col">نام و نام خانوادگی</th>
                          <th scope="col">شماره قرارداد</th>
                          <th scope="col">کارشناس فروش</th>
                          <th scope="col">کارشناس تماس گیرنده</th>
                          <th scope="col">مبلغ سرمایه گذاری</th>
                          <th scope="col">توضیحات</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in data">
                          <th scope="row">#{{ row.id }}</th>
                          <td>{{ row.phone }}</td>
                          <td>
                            <b-badge variant="light" class="text-dark"
                              >{{ row.name + " " + row.family }}
                            </b-badge>
                          </td>
                          <td>
                            <b-badge variant="light" class="text-dark"
                            >{{ row.unique_id }}
                            </b-badge>
                          </td>
                          <td>
                            <b-badge variant="light" class="text-dark">{{
                              row.seller
                                ? $root.full_name(
                                    row.seller.firstname,
                                    row.seller.lastname
                                  )
                                : ""
                            }}</b-badge>
                          </td>
                          <td>
                            <b-badge variant="light" class="text-dark">{{
                                row.caller
                                    ? $root.full_name(
                                        row.caller.firstname,
                                        row.caller.lastname
                                    )
                                    : ""
                              }}</b-badge>
                          </td>
                          <td>
                            {{ $root.number_format(row.amount) }}
                          </td>
                          <td>{{ row.description }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
                <a-row class="pagination">
                  <a-pagination
                    :total="total"
                    :item-render="$root.itemRender"
                    @change="getGuests(currentPage)"
                    v-model="currentPage"
                  />
                </a-row>
              </div>
            </div>
          </div>
        </a-card>
      </div>
    </div>
    <a-card title="تفکیک گزارش بر اساس سانس" :style="{ marginTop: '16px' }">

      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="card-title">
            <h6>گزارش فروش هر سانس</h6>
            <br />
          </div>
          <chart-line :height="310" :data="lineChartData"></chart-line>
        </div>
      </div>
    </a-card>
    <a-card :style="{ marginTop: '16px' }">
      <section class="w-100 p-4 text-center">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">شناسه</th>
                <th scope="col">ساعت شروع</th>
                <th scope="col">ساعت پایان</th>
                <th scope="col">میزان فروش</th>
                <th scope="col">مشاهده جزییات</th>
                <th scope="col">دانلود گزارش</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sans in info.sans">
                <th scope="row">#{{ sans.id }}</th>
                <td>
                  <b-badge variant="light" class="text-dark">{{
                    sans.start_hour
                  }}</b-badge>
                </td>
                <td>
                  <b-badge variant="light" class="text-dark">{{
                    sans.end_hour
                  }}</b-badge>
                </td>
                <td>
                  <b-badge variant="light" class="text-dark">{{
                    $root.number_format(sans.sold_amount)
                  }}</b-badge>
                </td>
                <td>
                  <ContractTable :seminar_id="info.id"  :sans_id="sans.id" />
                </td>
                <td>
                <a :style="{ margin: '16px 16px 0 0'}" type="link" target="_blank" :href="`${$store.state.baseUrl}/seminars/${info.id}/sans/${sans.id}/contracts`">دانلود گزارش </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </a-card>
    <a-card
      title="تفکیک گزارش بر اساس کارشناسان"
      :style="{ marginTop: '16px' }"
    >
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="card-title">
            <h6>گزارش فروش کارشناسان</h6>
            <br />
            <chart-bar :height="300" :data="barChartData"></chart-bar>
          </div>
        </div>
      </div>
    </a-card>
    <a-card :style="{ marginTop: '16px' }">
      <section class="w-100 p-4 text-center">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">شناسه</th>
                <th scope="col">کاربر</th>
                <th scope="col">سود کلی</th>
                <th scope="col">مبلغ حقوق کلی</th>
                <th scope="col">میزان فروش</th>
                <th scope="col">مشاهده جزییات</th>
                <th scope="col">دانلود گزارش</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="host in sellers">
                <th scope="row">#{{ host.id }}</th>
                <td>
                  <b-badge variant="light" class="text-dark">{{
                    host.user
                      ? $root.full_name(host.user.firstname, host.user.lastname)
                      : ""
                  }}</b-badge>
                </td>
                <td>
                  <b-badge variant="light" class="text-dark"
                    >{{ host.profit_percent }} %</b-badge
                  >
                </td>
                <td>
                  <b-badge variant="light" class="text-dark">{{
                    $root.number_format(host.salary)
                  }}</b-badge>
                </td>
                <td>
                  <b-badge variant="light" class="text-dark">{{
                    $root.number_format(host.sold_amount)
                  }}</b-badge>
                </td>
                <td>
                  <ContractTable :seminar_id="info.id"  :seller_id="host.user_id" />
                </td>
                <td>
                  <a :style="{ margin: '16px 16px 0 0'}" type="link" target="_blank" :href="`${$store.state.baseUrl}/seminars/${info.id}/seller/${host.user_id}/contracts`">دانلود گزارش </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </a-card>
      <a-card
              title="تفکیک گزارش بر اساس کال سنتر"
              :style="{ marginTop: '16px' }"
      >
          <div class="row justify-content-center">
              <div class="col-md-10">
                  <div class="card-title">
                      <h6>گزارش فروش کال سنتر</h6>
                      <br />
                      <chart-bar :height="300" :data="barChartDataCallCenter"></chart-bar>
                  </div>
              </div>
          </div>
      </a-card>
      <a-card :style="{ marginTop: '16px' }">
          <section class="w-100 p-4 text-center">
              <div class="table-responsive">
                  <table class="table">
                      <thead>
                      <tr>
                          <th scope="col">شناسه</th>
                          <th scope="col">کاربر</th>
                          <th scope="col">سود کلی</th>
                          <th scope="col">مبلغ حقوق کلی</th>
                          <th scope="col">میزان فروش</th>
                          <th scope="col">مشاهده جزییات</th>
                          <th scope="col">دانلود گزارش</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="host in caller">
                          <th scope="row">#{{ host.id }}</th>
                          <td>
                              <b-badge variant="light" class="text-dark">{{
                                  host.user
                                      ? $root.full_name(host.user.firstname, host.user.lastname)
                                      : ""
                                  }}</b-badge>
                          </td>
                          <td>
                              <b-badge variant="light" class="text-dark"
                              >{{ host.profit_percent }} %</b-badge
                              >
                          </td>
                          <td>
                              <b-badge variant="light" class="text-dark">{{
                                  $root.number_format(host.salary)
                                  }}</b-badge>
                          </td>
                          <td>
                              <b-badge variant="light" class="text-dark">{{
                                  $root.number_format(host.caller_sold_amount)
                                  }}</b-badge>
                          </td>
                          <td>
                              <ContractTable :seminar_id="info.id"  :caller_id="host.user_id" />
                          </td>
                          <td>
                              <a :style="{ margin: '16px 16px 0 0'}" type="link" target="_blank" :href="`${$store.state.baseUrl}/seminars/${info.id}/caller/${host.user_id}/contracts`">دانلود گزارش </a>
                          </td>
                      </tr>
                      </tbody>
                  </table>
              </div>
          </section>
      </a-card>
  </a-card>
</template>

<script>
import ChartBar from "../../components/Charts/ChartBar";
import ChartLine from "../../components/Charts/ChartLine";
import ContractTable from "../../components/Seminars/ModalTableGuest";

export default {
  components: {
    ChartBar,
    ChartLine,
    ContractTable,
  },
  data() {
    return {
      data: [],
      currentPage: 1,
      total: 0,
      loading: false,
      loading2: false,

      sellers: [],
      best_seller: {},
      caller: [],
      best_caller: {},
      info: {},
      barChartData: {
        labels: [],
        datasets: [
          {
            label: "میزان فروش ",
            backgroundColor: "#fff",
            borderWidth: 0,
            borderSkipped: false,
            borderRadius: 6,
            data: [],
            maxBarThickness: 20,
          },
        ],
      },
      barChartDataCallCenter: {
        labels: [],
        datasets: [
          {
            label: "میزان فروش ",
            backgroundColor: "#fff",
            borderWidth: 0,
            borderSkipped: false,
            borderRadius: 6,
            data: [],
            maxBarThickness: 20,
          },
        ],
      },

      lineChartData: {
        labels: [],
        datasets: [
          {
            label: "فروش سانس ",
            tension: 0.4,
            borderWidth: 0,
            pointRadius: 0,
            borderColor: "#B37FEB",
            borderWidth: 3,
            data: [],
            maxBarThickness: 6,
          },
        ],
      },
    };
  },

  methods: {
    async getData() {
      let _this = this;
      this.loading = true;

      await axios
        .get("/seminars/single/" + this.$route.params.id)
        .then(function (response) {
          _this.info = response.data;
          _this.sellers = _this.info.hosts.filter(
            (item) => item.seminar_role_id == 5
          );
            _this.caller = _this.info.hosts.filter(
                (item) => item.seminar_role_id == 28
            );

          _this.best_seller = _this.info.hosts.find(
            (item) => item.id == _this.info.best_seller.id
          );

              // _this.best_caller = _this.info.hosts.find(
              //     (item) => item.id == _this.info.best_caller.id
              // );
          const array = _this.lineChartData;
          array.labels = [];
          array.datasets[0].data = [];
          for (const sans of _this.info.sans) {
            array.labels.push(`${sans.start_hour}-${sans.end_hour}`);
            array.datasets[0].data.push(sans.sold_amount);
          }
          const array2 = _this.barChartData;
          array2.labels = [];
          array2.datasets[0].data = [];
          for (const seller of _this.sellers) {
            array2.labels.push(
              `${seller.user.firstname} ${seller.user.lastname}`
            );
            array2.datasets[0].data.push(seller.sold_amount);
          }

          const array3 = _this.barChartDataCallCenter;
          array3.labels = [];
          array3.datasets[0].data = [];
          for (const call of _this.caller) {
            array3.labels.push(
                `${call.user.firstname} ${call.user.lastname}`
            );
            array3.datasets[0].data.push(call.caller_sold_amount);
          }
          _this.loading = false;
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },

    async getGuests() {
      let _this = this;
      let url = `/seminars/contracts?page=${this.currentPage}&&seminar_id=${this.$route.params.id}`;
      axios
        .get(url)
        .then(function (response) {
            console.log(response,'res')
          _this.data = response.data.data.data;
          _this.total = response.data.data.total;
          _this.currentPage = response.data.data.current_page;
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },
  },
  mounted() {
    this.getData();
    this.getGuests();
  },
};
</script>

<style lang="scss"></style>
